/** The available search type options in the unified station search dropdown.
 * Requirements: 8.1 */
export type StationSearchType = 'stationCode' | 'wmo' | 'icao' | 'iata' | 'mgID' | 'mmi' | 'allTags';

/** Maps StationSearchType to the API tag key parameter.
 * Requirements: 8.1 */
export const SEARCH_TYPE_TO_TAG_KEY: Record<StationSearchType, string> = {
  stationCode: '',
  wmo: 'wmo',
  icao: 'icao',
  iata: 'iata',
  mgID: 'mgID',
  mmi: 'mmi',
  allTags: '',
};

/** Dropdown display configuration for the unified station search bar.
 * Requirements: 1.1 */
export const SEARCH_TYPE_OPTIONS: Array<{ value: StationSearchType; label: string }> = [
  { value: 'stationCode', label: 'Station Code' },
  { value: 'wmo', label: 'WMO' },
  { value: 'icao', label: 'ICAO' },
  { value: 'iata', label: 'IATA' },
  { value: 'mgID', label: 'MGID' },
  { value: 'mmi', label: 'MMI' },
  { value: 'allTags', label: 'All Tags' },
];

/** Parses raw input text into deduplicated, trimmed, non-empty search values.
 * Splits on commas, spaces, and tabs.
 * Requirements: 2.2, 2.6 */
export function parseSearchValues(rawInput: string): string[] {
  const values = rawInput
    .split(/[,\s\t]+/)
    .map(v => v.trim())
    .filter(v => v.length > 0);
  const unique = [...new Set(values)];
  return unique;
}

/** Returns the API tag key for a given StationSearchType.
 * Requirements: 8.2, 8.3, 8.4 */
export function mapSearchTypeToTagKey(searchType: StationSearchType): string {
  return SEARCH_TYPE_TO_TAG_KEY[searchType];
}
